import { useTranslation } from 'react-i18next'

import { ProfileFinishedWidget } from '../../../Widget'
import {
  useRequestProfileContext,
  useRequestProfileRatingActions,
} from '../../RequestProfile.hooks'
import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'

function RequestProfileWidgetFinished({ isSkeleton }) {
  const { t } = useTranslation()

  const { outboundUuid, requestData } = useRequestProfileContext()

  const { handleOpenRating } = useRequestProfileRatingActions()

  return (
    <ProfileFinishedWidget
      contentProps={{
        ...requestData,
        // Connected (iDWELL-to-iDWELL) requests have no proxied feedback
        // endpoint, so the rating is hidden entirely.
        isRatingHidden: Boolean(outboundUuid),
        onOpenRating: handleOpenRating,
      }}
      isSkeleton={isSkeleton}
      title={t('Widget.FinishedTitleKey')}
      widgetProps={{ qaName: RequestProfileWidgetKey.FINISHED }}
    />
  )
}

export default RequestProfileWidgetFinished
